/**
 * Product feature type for clinical categories, extras modalities and flexi-limit items
 */

export const ProductFeatureType = Object.freeze({
  INCLUDED: 'included',
  RESTRICTED: 'restricted',
  EXCLUDED: 'excluded',
});
